import { z } from "zod";

export const engineModeSchema = z.enum(["content", "placement"]);
export const audienceMarketSchema = z.enum(["CN", "US"]);
export const platformSchema = z.enum(["tiktok", "domestic"]);
export const outputLanguageSchema = z.enum(["zh", "en"]);
